import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const STORAGE_KEY = "xv_client_token";

export const clientApi = axios.create({
    baseURL: `${BACKEND}/api/client`,
});

clientApi.interceptors.request.use((config) => {
    const t = localStorage.getItem(STORAGE_KEY);
    if (t) config.headers = { ...config.headers, Authorization: `Bearer ${t}` };
    return config;
});

const Ctx = createContext({ client: null, ready: false, login: () => {}, redeem: () => {}, logout: () => {} });

export function ClientAuthProvider({ children }) {
    const [client, setClient] = useState(null);
    const [ready, setReady] = useState(false);

    const refresh = useCallback(async () => {
        const t = localStorage.getItem(STORAGE_KEY);
        if (!t) {
            setClient(null);
            setReady(true);
            return null;
        }
        try {
            const { data } = await clientApi.get("/auth/me");
            setClient(data);
            return data;
        } catch {
            localStorage.removeItem(STORAGE_KEY);
            setClient(null);
            return null;
        } finally {
            setReady(true);
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    const login = async (email, password) => {
        const { data } = await clientApi.post("/auth/login", { email, password });
        localStorage.setItem(STORAGE_KEY, data.access_token);
        await refresh();
        return data;
    };

    const redeem = async (token, password, name) => {
        const { data } = await clientApi.post("/auth/redeem", { token, password, name });
        localStorage.setItem(STORAGE_KEY, data.access_token);
        await refresh();
        return data;
    };

    const logout = () => {
        localStorage.removeItem(STORAGE_KEY);
        setClient(null);
    };

    return <Ctx.Provider value={{ client, ready, login, redeem, logout }}>{children}</Ctx.Provider>;
}

export const useClientAuth = () => useContext(Ctx);
